import React, { useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";

// icons
import { GrCheckboxSelected, GrCheckbox } from "react-icons/gr";
import { GiCancel } from "react-icons/gi";
import { MdMoneyOffCsred } from "react-icons/md";

// constants 
import { calculateTotalPaid, convertCurrency, convertImageToBase64, numberFormat } from "../../helper";
import { S3_URL } from "../../const";
import { useTranslation } from "react-i18next";

export default function BillforSale80({ Location, ordergroup, shopData, prepareRate }) {
  const [shop, setShop] = useState();
  const [isBillNumber, setIsBillNumber] = useState("bill_1");
  const [base64Image, setBase64Image] = useState("");
  const [ordersNow, sertOrderNow] = useState([])
  const { t } = useTranslation();
  
  // convert total price to kip
  const sumPrice = Location?.state?.state?.sumPrice ?? ordergroup?.sumPrice;
  const currency = Location?.state?.state?.currency ?? ordergroup.currency ?? "LAK";
  const rateBaht = parseFloat(Location?.state?.state?.rateBaht || ordergroup?.rateBaht || 1);
  const rateUsd = parseFloat(Location?.state?.state?.rateUsd || ordergroup?.rateUsd || 1);
  const totals = calculateTotalPaid(sumPrice, currency, prepareRate);

  const calculateSumKipFromOrders = (orders = []) => {
    return orders.reduce((sum, order) => {
      const base = parseFloat(order?.totalPrice || (order?.price * order?.amount) || 0);
      const cur = order?.currency || order?.stock?.currency;

      if (cur === "LAK" || cur === "ກີບ") return sum + base;
      if (cur === "BAHT" || cur === "ບາດ") return sum + (base * rateBaht);
      if (cur === "USD" || cur === "ໂດລາ") return sum + (base * rateUsd);
      return sum + base;
    }, 0);
  };

  // useEffect Hooks
  useEffect(() => {
    if (shopData) {
      setShop(shopData);

      const { isBillNumber, isLessStock, image } = shopData;
      setIsBillNumber(isBillNumber);

      const _getImage = S3_URL + shopData?.image;

      convertImageToBase64(_getImage).then((base64) => {
        setBase64Image(base64);
      });

    } else {
      let localDatas = JSON.parse(localStorage.getItem("SHOP_DATA"))
      setShop(localDatas);

      const { isBillNumber, isLessStock, image } = localDatas;
      setIsBillNumber(isBillNumber);

      const _getImage = S3_URL + localDatas?.image;

      convertImageToBase64(_getImage).then((base64) => {
        setBase64Image(base64);
      });
    }

  }, [shopData]);

  // useEffect Hooks
  useEffect(() => {
    sertOrderNow(ordergroup?.orders || ordergroup);

  }, [ordergroup]);

  return (
    <div style={{ padding: "0 15px" }}>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
        {base64Image &&
          <img src={base64Image} alt={shop?.name} style={{ maxWidth: 104, maxHeight: 104, }} />
        }

        <b style={{ fontSize: 20, marginTop: 5 }}>{shop?.name}</b>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <p style={{ fontSize: 12 }}>{shop?.address?.village + ", " + shop?.address?.district + ", " + shop?.address?.province}</p>
          <p style={{ marginTop: -3, fontSize: 12 }}>{shop?.phone ?? ""}</p>
        </div>
      </div>
      <div style={{ textAlign: "center", padding: 5 }}>
        <h3 style={{ fontSize: 18, fontWeight: "bold" }}>{isBillNumber === "bill_3" ? t("invoice_titleV2") : t("invoice_title")}</h3>
      </div>
      <div style={{ textAlign: "left", fontSize: 12 }}>
        {t("number_no")} : {Location?.state?.state.code ?? ordergroup?.code}{" "}
      </div>

      <div style={{ textAlign: "left", fontSize: 12 }}>
        {t("createdBy")} : {Location?.state?.state?.staff ?? ordergroup?.staff}{" "}
        {Location?.state?.state?.staffLastname ?? ordergroup?.staffLastname}{" "}
      </div>
      <div style={{ textAlign: "left", fontSize: 12 }}>
        {t("customer_name")}:{" "}
        {Location?.state?.state?.customerName ?? ordergroup?.customerName ?? "......................"}{" "}
        {Location?.state?.state?.customerLastName ?? ordergroup?.customerLastName ?? "......................"}{" "}
      </div>
      <div style={{ textAlign: "left", fontSize: 12 }}>
        {t("phone_number")}: {Location?.state?.state?.phone ?? ordergroup?.phone ?? "......................"}
      </div>
      <div style={{ textAlign: "left", fontSize: 12 }}>
        ຂໍ້ມູນປາຍທາງ: {Location?.state?.state?.addressCf ?? ordergroup?.addressCf ?? "......................"}
      </div>
      <div
        style={{
          textAlign: "left",
          fontSize: 12,
          borderBottom: "1px solid black",
        }}
      >
        {t("day_month_year")} :{" "}
        {moment(Location?.state?.state?.createdAt ?? ordergroup?.createdAt).format("DD/MM/YYYY HH:mm:ss")}
      </div>
      <div style={{ height: 5 }} />
      <Order>
        <>
          {ordersNow?.slice()
            .sort((a, b) => parseInt(a.sortId) - parseInt(b.sortId)).map((order, index) => (
              <div
                style={{
                  fontSize: 1,
                  lineHeight: 1.2,
                }}
                key={index}
              >
                <div style={{ textAlign: "left", fontSize: 14, display: "flex" }}>
                  <div style={{ fontWeight: "bold", marginRight: 10 }}>
                    {index + 1}
                  </div>
                  <div>
                     {order?.productName}
                     {order?.survival && shopData?.id==="63ec6d38c617221e6ccf5edc" && <span style={{color:"#a3a3a3ff",fontSize:11}}>ເລກລ໊ອຕ: {order?.survival}</span>}
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "left",
                    paddingLeft: 18,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p style={{ fontWeight: "bold", fontSize: 11, }}>
                    {" "}
                    {order?.amount} {order?.stock?.unit ?? order?.stock?.unitId?.name ?? ""} X{" "}
                    {order?.price ? numberFormat(order?.price) : "-"}{" "}
                    {" " + convertCurrency(order?.currency)} &nbsp; {order?.amountFree ? <>ແຖມ: {order?.amountFree ?? ""}</> : ""}
                  </p>
                  <p style={{ fontWeight: "bold", fontSize: 11, }}>
                    {numberFormat(order?.price * order?.amount)}
                    {" " + convertCurrency(order?.currency)}
                  </p>
                </div>
              </div>
            ))}


          <div style={{ display: "flex", marginTop: '-.2em', justifyContent: "space-between", borderTop: "1px solid black", margin: '12px 0' }}>
            <p style={{ fontWeight: 'bold', fontSize: 14 }}>{t("totals_name")} :</p>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", fontSize: 14, fontWeight: 'bold' }}>
              <span>
                {numberFormat(Location?.state?.state?.totalPrice ?? ordergroup?.totalPrice)} ₭
              </span>
              <span>
                {numberFormat(Location?.state?.state?.sumPriceBaht ?? ordergroup?.sumPriceBaht)}{" "}
                ฿
              </span>
              <span>
                {numberFormat(Location?.state?.state?.sumPriceUsd ?? ordergroup?.sumPriceUsd)}{" "} $
              </span>
            </div>
          </div>

          {/* <hr /> */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              borderBottom: "1px solid black",
            }}
          >

            {isBillNumber === "bill_2"? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>ລວມເປັນກີບ :</span>
                  <b style={{ fontSize: 18 }}>
                    {numberFormat(calculateSumKipFromOrders(ordersNow || [])) + ' ₭'}
                  </b>

                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>ລວມເປັນບາດ :</span>
                  <b style={{ fontSize: 18 }}>
                    {numberFormat((Location?.state?.state?.sumPriceBaht ?? ordergroup?.sumPriceBaht) || 0) + ' ฿'}
                  </b>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>ລວມເປັນໂດລາ :</span>
                  <b style={{ fontSize: 18 }}>
                    {numberFormat((Location?.state?.state?.sumPriceUsd ?? ordergroup?.sumPriceUsd) || 0) + ' $'}
                  </b>
                </div>
              </>
            ) : (
              <div className="w-100">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: 14,
                    fontWeight: "bold",
                  }}
                >
                  <span>{t("sum_amount")}</span>
                  <span>
                    {numberFormat((() => {
                      const orders = ordersNow?.length > 0 ? ordersNow : (Location?.state?.state?.orders || []);
                      if (orders?.length > 0) return calculateSumKipFromOrders(orders);
                      
                      const s = parseFloat(Location?.state?.state?.sumPrice || ordergroup?.sumPrice || 0);
                      const c = Location?.state?.state?.currency || ordergroup?.currency;

                      if (c === "LAK") return s;
                      if (c === "BAHT") return s * rateBaht;
                      if (c === "USD") return s * rateUsd;
                      return s;
                    })()) + ' ₭'}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: 12,
                    marginTop: 5
                  }}
                >
                  <span>ສ່ວນຫລຸດ:</span>
                  <span>
                    {numberFormat(Location?.state?.state?.discount ?? ordergroup?.discount ?? 0)} {(Location?.state?.state?.discountType ?? ordergroup?.discountType) ? "₭" : "%"}
                  </span>
                </div>

                <div
                  style={{
                    display: (Location?.state?.state?.costTitle ?? ordergroup?.costTitle) ? "flex" : "none",
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: 14,
                  }}
                >
                  <span>{Location?.state?.state?.costTitle ?? ordergroup?.costTitle ?? "ຄ່າຂົນສົ່ງ"}</span>
                  <span>
                    {numberFormat(Location?.state?.state?.shippingCost ?? ordergroup?.shippingCost) + ' ₭'}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: 14, fontWeight: 'bold',
                    marginTop: 5
                  }}
                >
                  <span>ລວມຈໍານວນເງິນທີ່ຕ້ອງຈ່າຍ:</span>
                  <span>
                    {numberFormat(Location?.state?.state?.receivedMoney ?? ordergroup?.receivedMoney ?? 0)} ກີບ
                  </span>
                </div>
              </div>
            )}
          </div>


          <div
            style={{
              fontSize: 12,
              display: "flex",
              width: "100%",
              justifyContent: "center",
              flexDirection: "column",
              marginBottom: 30,
              paddingTop: 5
            }}
          >
            {Location?.state?.state?.status === "NOTYETPAID" ?? ordergroup?.status === "NOTYETPAID" ? (
              <>
                <div>
                  <GrCheckbox /> {t("is_pay")}{" "}
                </div>
                <div>
                  <GrCheckboxSelected /> {t("not_pay")}{" "}
                </div>
              </>
            ) : Location?.state?.state?.status === "COMPLETED" ?? ordergroup?.status === "COMPLETED" ? (
              <>
                <div>
                  <GrCheckboxSelected /> {t("is_pay")}{" "}
                </div>
                <div>
                  <GrCheckbox /> {t("not_pay")}{" "}
                </div>
              </>
            ) : Location?.state?.state?.status === "CANCELLED" ?? ordergroup?.status === "CANCELLED" ? (
              <div>
                <GiCancel /> {t("return_order")}
              </div>
            ) : Location?.state?.state?.status === "INDEBTED" ?? ordergroup?.status === "INDEBTED" ? (
              <div>
                <MdMoneyOffCsred /> {t("in_debt")}
              </div>
            ) : (
              ""
            )}

            {(Location?.state?.state?.status !== "NOTYETPAID" ?? ordergroup?.status !== "NOTYETPAID") && <p>
              {t("pay_with_cash")}:{" "}
              {Location?.state?.state?.payment ?? ordergroup?.payment === "CASH"
                ? t("cash_money_name")
                : t("transfer_money_name")}
            </p>}


            <p style={{ fontSize: 12, marginTop: 2, textAlign: 'center', width: '100%' }}>{shopData?.descriptionPOSBill ?? "ຂອບໃຈລູກຄ້າທີ່ມາໃຊ້ບໍລິການ"}</p>


          </div>
        </>
      </Order>
    </div>
  );
}

const Order = styled.div`
  display: flex;
  flex-direction: column;
`;
